import TippsNoData from './TippsNoData'
export default TippsNoData
